import { Subject, interval } from 'rxjs'
import { distinctUntilChanged, map } from 'rxjs/operators'
import { isEqual } from 'lodash'
import { get } from 'axios'

const FETCH_INTERVAL = 1000 * 60 * 5
const subject = new Subject()

function doFetch() {
  if (!process.env.VUE_APP_SERVICE_STATUS_URL) {
    // 稼働状況取得URLが設定されていない場合は常に公開状態
    return Promise.resolve({ available: true })
  } else {
    return get(process.env.VUE_APP_SERVICE_STATUS_URL).then(r => r.data)
  }
}

async function fetchStatus() {
  try {
    const status = await doFetch()
    subject.next(status)
  } catch (e) {
    subject.error(e)
  }
}

interval(FETCH_INTERVAL).subscribe(fetchStatus)

/**
 * サービス稼働状況が変化したらステータス情報を流すObservable
 */
export const serviceStatus = subject.asObservable().pipe(
  map(status => ({ available: status.available, message: status.message })),
  distinctUntilChanged(isEqual),
)

/**
 * 現在のサービス稼働状況を取得する
 */
export function fetchCurrentStatus() {
  return doFetch()
}
